import { createBrowserRouter } from 'react-router-dom'
import routes from './routes'

function Router() {
  return createBrowserRouter(routes, { basename: '/' })
}

export default Router
